const pageNameKey = "otaInstallationCompleteModal";

export const otaInstallationCompleteModalEn = {
  [pageNameKey]: {
    titleFirmware: "Firmware Installation Complete",
    titleBackup: "Backup Installation Complete",
    subtitle: "Installation Successful",
    descriptionFirmware:
      "The firmware {itemName}{installationId} has been successfully installed on the machine.",
    descriptionBackup:
      "The backup {itemName}{installationId} has been successfully installed on the machine.",
    installationIdTemplate: " (Installation ID {ID})",
    completedStatus: "Completed",
    overallProgressLabel: "Overall progress",
    doneButtonText: "Done",
    titleCreateBackup: "Backup Creation Complete",
    subtitleCreateBackup: "Backup Successful",
    descriptionCreateBackup: "The backup has been successfully created.",
  },
};

export const otaInstallationCompleteModalPtBr = {
  [pageNameKey]: {
    titleFirmware: "Instalação de firmware concluída",
    titleBackup: "Instalação de backup concluída",
    subtitle: "Instalação bem-sucedida",
    descriptionFirmware:
      "O firmware {itemName}{installationId} foi instalado com sucesso na máquina.",
    descriptionBackup:
      "O backup {itemName}{installationId} foi instalado com sucesso na máquina.",
    installationIdTemplate: " (ID da instalacao {ID})",
    completedStatus: "Concluído",
    overallProgressLabel: "Progresso geral",
    doneButtonText: "Concluir",
    titleCreateBackup: "Criação de backup concluída",
    subtitleCreateBackup: "Backup bem-sucedido",
    descriptionCreateBackup: "O backup foi criado com sucesso.",
  },
};

export const otaInstallationCompleteModalDe = {
  [pageNameKey]: {
    titleFirmware: "Firmware-Installation abgeschlossen",
    titleBackup: "Backup-Installation abgeschlossen",
    subtitle: "Installation erfolgreich",
    descriptionFirmware:
      "Die Firmware {itemName}{installationId} wurde erfolgreich auf der Maschine installiert.",
    descriptionBackup:
      "Das Backup {itemName}{installationId} wurde erfolgreich auf der Maschine installiert.",
    installationIdTemplate: " (Installations-ID {ID})",
    completedStatus: "Abgeschlossen",
    overallProgressLabel: "Gesamtfortschritt",
    doneButtonText: "Fertig",
    titleCreateBackup: "Backup-Erstellung abgeschlossen",
    subtitleCreateBackup: "Backup erfolgreich",
    descriptionCreateBackup: "Das Backup wurde erfolgreich erstellt.",
  },
};

export const otaInstallationCompleteModalZhHans = {
  [pageNameKey]: {
    titleFirmware: "固件安装完成",
    titleBackup: "备份安装完成",
    subtitle: "安装成功",
    descriptionFirmware: "固件 {itemName}{installationId} 已成功安装到设备上。",
    descriptionBackup: "备份 {itemName}{installationId} 已成功安装到设备上。",
    installationIdTemplate: "（安装 ID {ID}）",
    completedStatus: "已完成",
    overallProgressLabel: "总体进度",
    doneButtonText: "完成",
    titleCreateBackup: "备份创建完成",
    subtitleCreateBackup: "备份成功",
    descriptionCreateBackup: "备份已成功创建。",
  },
};

export const otaInstallationCompleteModalIt = {
  [pageNameKey]: {
    titleFirmware: "Installazione firmware completata",
    titleBackup: "Installazione backup completata",
    subtitle: "Installazione riuscita",
    descriptionFirmware:
      "Il firmware {itemName}{installationId} è stato installato con successo sulla macchina.",
    descriptionBackup:
      "Il backup {itemName}{installationId} è stato installato con successo sulla macchina.",
    installationIdTemplate: " (ID installazione {ID})",
    completedStatus: "Completato",
    overallProgressLabel: "Progresso complessivo",
    doneButtonText: "Fatto",
    titleCreateBackup: "Creazione backup completata",
    subtitleCreateBackup: "Backup riuscito",
    descriptionCreateBackup: "Il backup è stato creato con successo.",
  },
};

export const otaInstallationCompleteModalEs = {
  [pageNameKey]: {
    titleFirmware: "Instalación de firmware completada",
    titleBackup: "Instalación de respaldo completada",
    subtitle: "Instalación exitosa",
    descriptionFirmware:
      "El firmware {itemName}{installationId} se ha instalado correctamente en la máquina.",
    descriptionBackup:
      "El respaldo {itemName}{installationId} se ha instalado correctamente en la máquina.",
    installationIdTemplate: " (ID de instalacion {ID})",
    completedStatus: "Completado",
    overallProgressLabel: "Progreso general",
    doneButtonText: "Listo",
    titleCreateBackup: "Creación de respaldo completada",
    subtitleCreateBackup: "Respaldo exitoso",
    descriptionCreateBackup: "El respaldo se ha creado correctamente.",
  },
};

export const otaInstallationCompleteModalNl = {
  [pageNameKey]: {
    titleFirmware: "Firmware-installatie voltooid",
    titleBackup: "Back-upinstallatie voltooid",
    subtitle: "Installatie geslaagd",
    descriptionFirmware:
      "De firmware {itemName}{installationId} is succesvol op de machine geïnstalleerd.",
    descriptionBackup:
      "De back-up {itemName}{installationId} is succesvol op de machine geïnstalleerd.",
    installationIdTemplate: " (Installatie-ID {ID})",
    completedStatus: "Voltooid",
    overallProgressLabel: "Algemene voortgang",
    doneButtonText: "Klaar",
    titleCreateBackup: "Back-up maken voltooid",
    subtitleCreateBackup: "Back-up geslaagd",
    descriptionCreateBackup: "De back-up is succesvol gemaakt.",
  },
};

export const otaInstallationCompleteModalTr = {
  [pageNameKey]: {
    titleFirmware: "Firmware Kurulumu Tamamlandı",
    titleBackup: "Yedekleme Kurulumu Tamamlandı",
    subtitle: "Kurulum Başarılı",
    descriptionFirmware:
      "{itemName}{installationId} ürün yazılımı makineye başarıyla kuruldu.",
    descriptionBackup:
      "{itemName}{installationId} yedeği makineye başarıyla kuruldu.",
    completedStatus: "Tamamlanmış",
    overallProgressLabel: "Genel ilerleme",
    doneButtonText: "Tamamlamak",
    installationIdTemplate: "(Kurulum Kimliği {ID})",
    titleCreateBackup: "Yedek Oluşturma Tamamlandı",
    subtitleCreateBackup: "Yedekleme Başarılı",
    descriptionCreateBackup: "Yedek başarıyla oluşturuldu.",
  },
};
